import React from 'react';
import DashboardLayout from './DashboardLayout';

export const dashboardLayout = props => {
    return (
        <div>
            <DashboardLayout {...props} />
        </div>
    );
};
